import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Provider, ApplicationRef, APP_INITIALIZER, PLATFORM_ID } from '@angular/core';
import { MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';

export function provideLazyToast(): Provider {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: (appRef: ApplicationRef, msgSvc: MessageService, platformId: Object) => () =>
        // Wait for the first toast request
        isPlatformServer(platformId)
          ? of(true)
          : msgSvc.messageObserver.pipe(take(1)).subscribe(async firstMessage => {
              const { ToastNotificationComponent } = await import('@usheru-hff/ui/toast-notification');
              const host = document.createElement('app-toast-root');
              document.body.appendChild(host);
              appRef.bootstrap(ToastNotificationComponent, host);
              Array.isArray(firstMessage) ? msgSvc.addAll(firstMessage) : msgSvc.add(firstMessage);
            }),
      deps: [ApplicationRef, MessageService, PLATFORM_ID],
      multi: true
    }
  ];
}
